<template>
    <div class="home_page">
        <img class="banner" src="../assets/ju/banner.jpg" alt="">
        <div class="title">
            关于我们
        </div>
        <p class="p_li">太原巴卡巴科技有限公司是一家专注于数字内容创作与分发的科技公司，致力于为用户提供高质量的漫剧和短剧内容。</p>
        <p class="p_li">我们拥有一支经验丰富的团队，在内容创作、技术开发和运营推广方面具有深深的积累。通过不断创新和优化，我们致力于打造行业领先的数字内容平台，为用户带来更加丰富多样的娱乐体验。</p>
        <p class="p_li">公司始终坚持以用户为中心，以内容质量为核心竞争力，不断推出符合市场需求的优质产品，赢得了广大用户的认可和信赖。</p>
    </div>
</template>
<script setup>
    import { navTo, navToDetail } from '../utils/utils'
    import { ref,onMounted,onUnmounted } from "vue";
    import {homeCarouselChart, homeList, homeRankList, useInfoApi } from '@/utils/api'
    import MainSwiper from '../components/mainSwiper.vue'
    import icon1 from '../assets/image/icon_yuanchuangtougao.png'
    import icon2 from '../assets/image/icon_quanwangresou.png'
    import icon3 from '../assets/image/icon_meirigenxin.png'
    import icon4 from '../assets/image/icon_cainixihuan.png'
    import coverPageList from '../components/coverPageList.vue'
    import hotPageList from '../components/hotList.vue'
    import dayPageList from '../components/dayPageList.vue'
    import topPageList from '../components/TopPageList.vue'
    import likePageList from '../components/likePageList.vue'
    import footerVue from '../components/footer.vue';
    let myList = ref([])
    let topListTit=ref([])
    let topListCon=ref([])
    onMounted(()=> {
        getInit()
    })
    let getInit=()=>{
        homeList().then(res=>{
            if(res.data.columnOneVOList){
                let list = res.data.columnOneVOList
                myList.value = list
                if(list.some((item)=> item.style == -1)){
                    // 有-1就展示排行榜
                    homeRankList({coverType: 2}).then(res=>{
                        let titList = []
                        let conList = []
                        let list = res.data
                        for (let i in list){
                           titList.push({name:list[i].columnName})
                           if(list[i].comicShowVOList.length>6){
                               conList.push(list[i].comicShowVOList.splice(0,6))
                           }else{
                               conList.push(list[i].comicShowVOList)
                           }
                        }
                        topListTit.value = titList
                        topListCon.value = conList
                    })
                }
            }
        })
    }

</script>
<style lang="scss" scoped>
.home_page{
    width: 100%;
    margin: 0 auto;
    padding:0 0 100px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    .banner{
        width: 100%;

    }
    .title{
        margin-top: 40px;
        font-size: 30px;
        color: #000000;
        font-weight: bold;
        margin-bottom: 50px;
    }
    .p_li{
       width: 900px;
        font-size: 16px;
        margin-top: 10px;
    }
}
.bannerSwiper{
        margin: 60px auto 60px; 
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        width: 100%;
        height: 250px !important;
        img{
            width: 100%;
            height: 250px !important;
        }
    }

    .home-wrap{
        background-color: #fff;
        height: 100%;
        margin: auto;
        .nav-title{
            display: flex;
            align-items: center;
            margin: 50px 0 30px 0;
            img{
                width: 36px;
                height: 36px;
                margin-right: 12px;
            }
            p{
                width: 112px;
                height: 40px;
                font-size: 28px;
                font-family: PingFangSC, PingFang SC;
                
                color: #333333;
                line-height: 40px;
            }
        }
        // .nav-origin{
        //     width: 100%;
        //     // height: 200px;
        //     background-color: lightblue;
        // }
        // .nav-hot{
        //     width: 100%;
        //     // height: 200px;
        //     background-color:lightcoral;
        // }
        // .nav-update{
        //     width: 100%;
        //     // height: 200px;
        //     background-color:lightgreen;
        // }
    }

    
</style>